import { useContext } from "react";

import { useFlags } from "launchdarkly-react-client-sdk";
import { Button } from "primereact/button";

import { SegmentedProgressBar } from "sj-ui-toolkit/src/atlas/components";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";

import { useLearnContext } from "../../../../../context/LearnContext";
import { VideoContext } from "../../VideoContext";

import QuizReviewQuestions from "./QuizReviewQuestions";

import S from "./_styles.module.scss";

const segmentColors = {
  requiredScore: themeClasses.bgIndigoDataviz2,
  userScore: themeClasses.bgIndigoDataviz1,
  totalScore: themeClasses.bgIndigoDataviz5,
};

export default function QuizReview() {
  const { isTournament } = useLearnContext();
  const { quiz, isLessonComplete, onLessonFinish, onQuizRetake, onExerciseLaunch } =
    useContext(VideoContext);
  const { quizRedesign } = useFlags();

  const passed = quiz.assessment.result === "passed";
  const passDiff = quiz.assessment.assessmentScore > 80 ? 0 : 80 - quiz.assessment.assessmentScore;
  const totalDiff =
    quiz.assessment.assessmentScore > 80 ? 100 - quiz.assessment.assessmentScore : 20;

  const segments = [
    {
      key: "userScore",
      value: quiz.assessment.assessmentScore,
      label: "Your Score",
    },
    {
      key: "requiredScore",
      value: passDiff,
      label: "Required Score",
    },
    {
      key: "totalScore",
      value: totalDiff,
      label: "Total Score",
    },
  ];

  return (
    <>
      <div className={S.quizBody}>
        <div className="flex flex-col gap-1.5">
          <h2 className="atlas-h1">{passed ? "Nicely done." : "So close."}</h2>
          <span className="body-lg text-muted-aaa">
            {passed
              ? "You successfully completed the quiz."
              : "Select the Retry quiz button to try again."}
          </span>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3 className="atlas-h5">Quiz score</h3>
          <SegmentedProgressBar
            segments={segments}
            segmentColors={segmentColors}
            height="h-5"
            ariaLabel="Quiz score"
          />
          <div className="flex justify-between">
            <span className="body-sm text-muted-aaa">
              Your score: {quiz.assessment.assessmentScore}%
            </span>
            <span className="body-sm text-muted-aaa self-end">80% needed to pass</span>
          </div>
        </div>
        {quizRedesign && <QuizReviewQuestions />}
      </div>
      <div className={S.quizFooter}>
        {!passed && (
          <div className="flex justify-end">
            <Button label="Retry quiz" icon="pi pi-replay" onClick={onQuizRetake} />
          </div>
        )}

        {passed && (
          <div className="flex gap-4 justify-end">
            {!isTournament && (
              <Button
                label="Take this quiz again"
                icon="pi pi-replay"
                severity="secondary"
                onClick={onQuizRetake}
              />
            )}
            {isLessonComplete ? (
              <Button label="Finish this lesson" icon="pi pi-check" onClick={onLessonFinish} />
            ) : (
              <Button
                className="self-start"
                label="Complete the exercise"
                onClick={onExerciseLaunch}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}
